import{C as o,d as e}from"./customer-overview-component2.js";const r=o,s=e;export{r as CustomerOverviewComponent,s as defineCustomElement}